export const TimeOffset = () => (new Date()).getTimezoneOffset() * (-1) * 60;

export const DurationConverter = (seconds, format = 'll') => {
    if (seconds === undefined) return '-';

    function getSubDate(date, position) {
        return parseInt(date.substr(position, 2));
    }

    const date = new Date(0);
    date.setSeconds(seconds);

    const isoDate = date.toISOString();
    const times = {
        hours: (getSubDate(isoDate, 8) - 1) + getSubDate(isoDate, 11),
        minutes: getSubDate(isoDate, 14),
        seconds: getSubDate(isoDate, 17),
    };

    const type = `${format}-${times.hours > 0 ? 'full' : 'short'}`

    function normalize(time) {
        return time < 10 ? '0'+time : time;
    }

    switch (type) {
        case 'll-full':
            return `${normalize(times.hours)}:${normalize(times.minutes)}:${normalize(times.seconds)}`
        case 'll-short':
            return `${normalize(times.minutes)}:${normalize(times.seconds)}`
        case 'llll-full':
            return `${times.hours}h ${times.minutes}m ${times.seconds}s`
        case 'llll-short':
            return `${times.minutes}m ${times.seconds}s`
    }
}